import { lazy, Suspense } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import Layout from '../components/layout/Layout';

// Componente de carga
const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-accent-600"></div>
  </div>
);

// Páginas
const Home = lazy(() => import('../pages/Home'));
const Products = lazy(() => import('../pages/Products'));
const Solutions = lazy(() => import('../pages/Solutions'));
const Resources = lazy(() => import('../pages/Resources'));
const AboutUs = lazy(() => import('../pages/AboutUs'));
const Contact = lazy(() => import('../pages/Contact'));
const Privacy = lazy(() => import('../pages/Privacy'));
const Locations = lazy(() => import('../pages/Locations'));
const Cookies = lazy(() => import('../pages/Cookies'));
const CookiePolicy = lazy(() => import('../pages/CookiePolicy'));
const Terms = lazy(() => import('../pages/Terms'));

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <Home />
          </Suspense>
        ),
      },
      {
        path: 'productos',
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <Products />
          </Suspense>
        ),
      },
      {
        path: 'soluciones',
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <Solutions />
          </Suspense>
        ),
      },
      {
        path: 'recursos',
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <Resources />
          </Suspense>
        ),
      },
      {
        path: 'nosotros',
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <AboutUs />
          </Suspense>
        ),
      },
      {
        path: 'contacto',
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <Contact />
          </Suspense>
        ),
      },
      {
        path: 'privacidad',
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <Privacy />
          </Suspense>
        ),
      },
      {
        path: 'ubicaciones',
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <Locations />
          </Suspense>
        ),
      },
      {
        path: 'cookies',
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <Cookies />
          </Suspense>
        ),
      },
      {
        path: 'politica-cookies',
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <CookiePolicy />
          </Suspense>
        ),
      },
      {
        path: 'terminos',
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <Terms />
          </Suspense>
        ),
      },
    ],
  },
]); 